import { render, staticRenderFns } from "./Autenticacion.vue?vue&type=template&id=27874aeb"
import script from "./Autenticacion.vue?vue&type=script&lang=js"
export * from "./Autenticacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports